import { Label } from "@/components/ui/label";
import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";
import { forwardRef } from "react";

interface SectionHeaderProps extends React.HTMLAttributes<HTMLElement> {
    title:string,
    description:string
}

export const SectionHeader = forwardRef<HTMLHeadingElement,SectionHeaderProps>(({title,description,...props}, ref) => {
    return(
        <>
        <div className={cn("space-y-0.5 text-xl md:text-2xl",props.className)}>
            <h2 className="font-bold tracking-tight"><span>{title}</span></h2>
            <p className="text-muted-foreground text-base">
                <span>{description}</span>
            </p>
        </div>
        <Separator  />        
        </>
        );
});


export const SectionMiniHeader = forwardRef<HTMLHeadingElement,SectionHeaderProps>(({title,description,...props}, ref) => {
    return(
        <>
        <div className={cn(props.className,"")}>
            <Label className="text-lg font-semibold mt-4"><span>{title}</span></Label>
            <p className="text-sm text-muted-foreground">
                <span>{description}</span>
            </p>
        </div>
        <Separator  />        
        </>
        );
});

